import React, { useState } from 'react';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  Grid,
  Backdrop,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import Controls from '../controls/Controls';
import ClaimSubform from './ClaimSubform';
import ClaimsAdjud from './ClaimsAdjud';
import { ClaimDocuments } from '../reports/claims/ClaimDocuments';
import ClaimsApproval from './ClaimsAppoval';

export default function ClaimsProcess() {
  const tenant = sessionStorage.getItem('userRefId');
  const [index, setIndex] = useState(0);
  const { claimNo } = useClaimsContext();
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  console.log('Number(tenant)', Number(tenant));
  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <Typography component="span" variant="h6" gutterBottom>
            Process Claim
          </Typography>
        </Grid>
      </Grid>
      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Claim Detail" />
              <Tab label="Services Claimed" />
              <Tab label="Documents" />
              {Number(tenant) < 30 && <Tab label="Approvals" />}
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            <ClaimsAdjud />
          </Panel>
          <Panel value={index} index={1}>
            <ClaimSubform />
          </Panel>
          <Panel value={index} index={2}>
            <ClaimDocuments refId={claimNo} />
          </Panel>
          {Number(tenant) < 30 && (
            <Panel value={index} index={3}>
              <ClaimsApproval />
            </Panel>
          )}
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
